import { render, staticRenderFns } from "./EntityActions.vue?vue&type=template&id=5c6c480a&scoped=true"
import script from "./EntityActions.vue?vue&type=script&lang=js"
export * from "./EntityActions.vue?vue&type=script&lang=js"
import style0 from "./EntityActions.vue?vue&type=style&index=0&id=5c6c480a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c480a",
  null
  
)

export default component.exports